import React, { useReducer } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

const reducer = (state, action) => {
  const {type, title, message, onConfirm} = action;
  switch (type) {
    case 'close':
      return ({alert: null});
    case 'primary':
      return ({alert: <SweetAlert primary title={title} onConfirm={onConfirm}>{message}</SweetAlert>});
    case 'success':
      return ({alert: <SweetAlert success title={title} onConfirm={onConfirm}>{message}</SweetAlert>});
    case 'info':
      return ({alert: <SweetAlert info title={title} onConfirm={onConfirm}>{message}</SweetAlert>});
    case 'warning':
      return ({alert: <SweetAlert warning title={title} onConfirm={onConfirm}>{message}</SweetAlert>});
    case 'danger':
      return ({alert: <SweetAlert danger title={title} onConfirm={onConfirm}>{message}</SweetAlert>});
    default:
      throw new Error();
  }
};

const AlertContext = React.createContext({alert: null});

const AlertProvider = (props) => {
  var [state, dispatch] = useReducer(reducer, {alert: null});
  return (
    <AlertContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AlertContext.Provider>
  );
};

export { AlertContext, AlertProvider };